import { MODAL_ADD_FILTROS,  } from "./../actions/actInvitadosVirtuales";

const initialState = {
  modalAddFiltros: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_ADD_FILTROS:
      return Object.assign({}, state, {
        modalAddFiltros: action.show,
      });
    default:
      return state;
  }
};

export default reducer;